import type { NodeDefinitionDto } from '@api/nodeDefinitions';
import type { SelectFieldOption } from './nodes/selectFieldOption';
import { OUTPUT_PORT_KIND_OPTIONS } from './portKindOptions';

export function stringList(raw: unknown): string[] {
  return Array.isArray(raw)
    ? raw.filter((id): id is string => typeof id === 'string')
    : [];
}

/** A union: one runner has to serve the whole selection. */
export function requiredAppsForSkills(
  map: Readonly<Record<string, readonly string[]>> | null | undefined,
  skillIdsRaw: unknown,
): string[] {
  if (!map) return [];
  return [...new Set(stringList(skillIdsRaw).flatMap((id) => map[id] ?? []))];
}

/** The one answer to "which kinds may this node output": the union, matching
 *  `allowedOutputKindsUnion` at publish. `map['']` is the not-yet-picked case. */
export function resolveOutputKindOptions(
  definition: NodeDefinitionDto | undefined,
  skillIdsRaw: unknown,
): readonly SelectFieldOption[] {
  const map = definition?.agentOutputKinds;
  if (!map) return OUTPUT_PORT_KIND_OPTIONS;
  const ids = stringList(skillIdsRaw);
  if (ids.length <= 1) {
    return map[ids[0] ?? ''] ?? map[''] ?? OUTPUT_PORT_KIND_OPTIONS;
  }
  const widest = map[''] ?? OUTPUT_PORT_KIND_OPTIONS;
  const allowed = new Set(
    ids.flatMap((id) => (map[id] ?? widest).map((o) => o.value)),
  );
  return widest.filter((o) => allowed.has(o.value));
}
